/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */
import React, { useContext, useEffect, useState } from 'react';
import styles from '../styles.module.scss';
import axiosInstance from '../../../../../../axios_instance';
import {
  IsAdminContext, NumberOfProjectsContext, ProjectListContext, UserProjectsDataContext
} from '../../../../../../context';
import { Row, Skeleton } from 'antd';
import { useParams } from 'react-router-dom';
import { reorder } from '../../../../../../utils/helper';
import swal from "sweetalert";
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import ProjectDetail from './project-detail-view';
import AddProject from './add-project';

//The parent component of core Project's card
const ProjectCard: React.FC<any> = (): JSX.Element => {
  const [userProjectData, setUserProjectData] = useState<any>([]);
  const { numberOfProjects, setNumberOfProjects } = useContext(NumberOfProjectsContext);
  //state to store all Projects from database
  const [ProjectList, setProjectList] = useState<any>();
  //state to enable add new content.If its true,add form will appear.
  const [addNew, setAddNew] = useState<boolean>(false);
  //context to check whether the logged in user is admin or normal user.
  const isAdmin = useContext(IsAdminContext);
  //this query parameter in URL will be available if the user is admin
  const { employeeId } = useParams();
  const [message, setMessage] = useState<string>()
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [companyOptions, setCompanyOptions] = useState<any>([]);

  useEffect(() => {
    let url = '';
    if (isAdmin === '1') {
      url = '/api/v1/admin/user-profiles/' + employeeId + '/experiences';
    } else {
      url = '/api/v1/profile/user-profiles/experiences';
    }
    axiosInstance.get(url).then((response) => {
      const orderedExperiences = response.data.order.map((experienceId: number) =>
        response.data.experiences.find((experience: any) => experience.experience_id === experienceId)
      ).filter((item: any) => item !== undefined);
      const options = orderedExperiences.map((experience: any) => ({
        label: experience.company_name,
        value: experience.company_name
      }));
      setCompanyOptions(options.length ? [...options, { label: "Others", value: "Others" }] : [{ label: "Others", value: "Others" }]);
    }).catch((error) => {
      setMessage("Something went wrong!Items couldn't be loaded!")
    }).finally(() => {
      setIsLoading(false)
    });
  }, []);

  //retrieve all Projects from database.User can select Project from available Projects in this list.
  useEffect(() => {
    axiosInstance.get('/api/v1/profile/user-profiles/projects').then((response) => {
      const projects = response.data.projects.reduce(
        (initialList: Object, CurrentList: { [key: string]: any }) => ({
          ...initialList,
          [CurrentList.project_name]: CurrentList.project_id,
        }),
        {}
      );
      setProjectList(projects);
    });
  }, []);

  //retrieve user's all Projects information.
  useEffect(() => {
    let url = '';
    if (isAdmin === '1') {
      url = '/api/v1/profile/admin/user-profiles/' + employeeId + '/projects';
    } else {
      url = '/api/v1/profile/user-profiles/projects';
    }
    axiosInstance.get(url).then((response) => {
      let userProjects: Array<any> = [];
      if (response.data.projects.length !== 0) {
        userProjects = response.data.projects.filter(
          (project: any) =>
            project['status']['id'] === 1
        );
        const orderedProjects = response.data.order && response.data.order.length > 0
          ? response.data.order
              .map((projectId: number) =>
                userProjects.find((userProject: any) => userProject.project_id === projectId)
              )
              .filter((item: any) => item !== undefined)
          : userProjects;
        setUserProjectData(orderedProjects);
        setNumberOfProjects(orderedProjects.length);
      } else {
        setUserProjectData(response.data.projects);
        setNumberOfProjects(0);
      }
    }).catch((error) => {
      console.log(error);
      setMessage("Something went wrong!Items couldn't be loaded!")
    }).finally(() => {
      setIsLoading(false)
    });
  }, []);

  const onDragEnd = (result: any) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    if (userProjectData.length < 2) {
      return;
    }
    if (result.source.index === result.destination.index) {
      return;
    }

    const items = reorder(
      userProjectData,
      result.source.index,
      result.destination.index
    );
    const order_list = items.map((item: any) =>
      item.project_id
    );
    setUserProjectData(
      items
    );

    const payload: any = {
      type: "projects",
      updated_reorder_list: order_list
    };
    if (isAdmin === '1') {
      payload.profile_id = employeeId;
    }

    axiosInstance.post("/api/v1/reorder", payload).then((response) => {
      swal({
        title: 'Updated',
        text: 'Order of project has been updated',
        icon: "success",
      }).then((willRefresh) => {
        console.log()
      });
    }).catch((error) => {
      swal({
        title: 'Failed',
        text: 'Order of project could not be updated',
        icon: "error",
      }).then((willRefresh) => {
        console.log()
      });
    })

  }

  return (
    <div style={{ position: 'relative' }}>
      <UserProjectsDataContext.Provider
        value={{ userProjectData, setUserProjectData }}
      >
        <ProjectListContext.Provider value={{ ...ProjectList }}>
          {isLoading ? <Skeleton active /> : <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable">
              {(provided: any, snapshot: any) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {userProjectData && userProjectData.map((item: any, index: any) => {
                    item.companyOptions = companyOptions;
                    return (
                      <Draggable key={`row_${item.project_id}`} draggableId={`row_${item.project_id}`} index={index}>
                        {(provided: any, snapshot: any) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <ProjectDetail
                              key={index}
                              {...item}
                            />
                          </div>
                        )}
                      </Draggable>
                    )
                  })}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>}
          {message ? <p style={{ color: "red" }}>{message}</p> : <></>}
          {addNew ? <AddProject {...{ setAddNew: setAddNew, companyOptions: companyOptions }} /> : <></>}

          <Row style={{ position: 'relative' }}>
            <p
              className={styles['add-new']}
              // eslint-disable-next-line @typescript-eslint/no-unused-vars
              onClick={(e) => {
                setAddNew(true);
              }}
            >
              Add New (+)
            </p>
          </Row>
        </ProjectListContext.Provider>
      </UserProjectsDataContext.Provider>
    </div>
  );
};

export default ProjectCard;
